import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export function ProtectedRoute() {
  const { user, userProfile, alunoProfile, loading, signOut, isRestricted } = useAuth();
  const location = useLocation();

  // 1. Enquanto o estado de autenticação ou o perfil do usuário estão sendo carregados, exibe um spinner.
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // 2. Se não há usuário autenticado, redireciona para a página de login.
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 3. Se o usuário está autenticado e o perfil foi carregado, determina o tipo de portal.
  const isStudentOrResponsible = isRestricted;

  const perfilNome = userProfile?.perfil?.nome?.toLowerCase();

  const studentPortalPath = '/portal-aluno';
  const mainSystemDefaultPath = '/home';

  // Lógica específica para alunos/responsáveis
  if (isStudentOrResponsible) {
    // NEW: Check for inactive or un-enrolled students
    if (perfilNome === 'aluno' && alunoProfile) {
      if (!alunoProfile.turma_id || alunoProfile.ativo === false) {
        // Renderiza mensagem de erro em vez de redirecionar para evitar loop infinito
        return (
          <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
            <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6 text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-error-warning-line text-3xl text-red-600"></i>
              </div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">Acesso Restrito</h2>
              <p className="text-gray-600 mb-6">
                {alunoProfile.ativo === false
                  ? 'Sua matrícula está inativa. Entre em contato com a secretaria.'
                  : (
                    <>
                      Olá <span className="font-bold capitalize">{userProfile?.nome?.split(' ')[0].toLowerCase()}</span>, você ainda não foi matriculado em uma turma. Aguarde até que sua matrícula seja efetivada para acessar o portal.
                    </>
                  )}
              </p>
              <button
                onClick={async () => {
                  await signOut();
                  // Redirect handled by signOut usually, but strictly ensuring login page:
                  window.location.href = '/login';
                }}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors w-full"
              >
                Voltar para Login
              </button>
            </div>
          </div>
        );
      }
    }

    // Se um aluno/responsável está tentando acessar uma rota que NÃO é do portal do aluno, redireciona.
    if (!location.pathname.startsWith(studentPortalPath)) {
      return <Navigate to={studentPortalPath} replace />;
    }
  } else {
    // Lógica para outros perfis (administrador, professor, etc.)
    // Se um usuário não-aluno/responsável está tentando acessar o portal do aluno, redireciona para o default do sistema principal.
    if (location.pathname.startsWith(studentPortalPath)) {
      return <Navigate to={mainSystemDefaultPath} replace />;
    }
  }

  // 5. Se o usuário está autenticado e na rota correta (ou uma sub-rota dela),
  // ou se é um usuário do sistema principal e não está tentando acessar o portal do aluno,
  // renderiza o conteúdo aninhado da rota.
  return <Outlet />;
}